// Thème global aligné avec l'app mobile
// Ne pas modifier sans vérifier la compatibilité avec l'app mobile

export const THEME = {
  // Gradient de fond (du haut vers le bas)
  gradients: {
    background: ['#B8D4E3', '#A7D3D8', '#9ECDC4', '#A8D5BA', '#B5DCAE'],
    backgroundCSS: 'linear-gradient(180deg, #B8D4E3 0%, #A7D3D8 25%, #9ECDC4 50%, #A8D5BA 75%, #B5DCAE 100%)',
    button: ['#4A90A4', '#6BB5A2'],
    buttonCSS: 'linear-gradient(135deg, #4A90A4 0%, #6BB5A2 100%)',
    selected: ['#4A90A4', '#5BBFBD'],
    selectedCSS: 'linear-gradient(135deg, #4A90A4 0%, #5BBFBD 100%)',
  },

  // Couleurs primaires
  colors: {
    primary: '#4A90A4',
    primaryDark: '#3A7A8A',
    secondary: '#6BB5A2',
    
    // Textes
    text: '#333333',
    textLight: '#666666',
    textMuted: '#999999',
    
    // Statuts
    success: '#27AE60',
    successLight: '#4CAF50',
    warning: '#F39C12',
    warningDark: '#E67E22',
    error: '#E74C3C',
    info: '#3498DB',
    
    // Fonds
    white: '#FFFFFF',
    background: '#F5F5F5',
  },

  // Couleurs spécifiques Chat
  chat: {
    // Bulle question utilisateur (gradient)
    userBubble: ['#4FBDBA', '#5BBFBD'],
    userBubbleCSS: 'linear-gradient(135deg, #4FBDBA 0%, #5BBFBD 100%)',
    userBubbleFollowUp: ['#7ECFCD', '#8DD5D3'],
    userBubbleFollowUpCSS: 'linear-gradient(135deg, #7ECFCD 0%, #8DD5D3 100%)',
    
    // Bulle réponse IA
    aiBubble: '#FFFFFF',
    aiBubbleText: '#333333',
    
    // Zone de saisie
    inputBorder: '#5BBFBD',
    inputBackground: '#FFFFFF',
    
    // Boutons feedback
    feedbackYellow: { bg: '#FFF9E6', border: '#F5D79E', text: '#E67E22' },
    feedbackGreen: { gradient: 'linear-gradient(135deg, #4CAF50 0%, #45B7AA 100%)' },
    feedbackBlue: { bg: '#F0F8FF', border: '#87CEEB', text: '#4A90A4' },
    
    // Bouton quiz
    quizButton: 'linear-gradient(135deg, #9B59B6 0%, #8E44AD 100%)',
    quizButtonDisabled: 'linear-gradient(135deg, #CCCCCC 0%, #BBBBBB 100%)',
  },

  // Couleurs spécifiques Quiz
  quiz: {
    progressDot: '#E0E0E0',
    progressDotCompleted: '#4CAF50',
    
    answerButton: '#FFFFFF',
    answerButtonCorrect: { bg: '#E8F5E9', border: '#4CAF50' },
    answerButtonWrong: { bg: '#FFF3E0', border: '#FFAB91' },
    
    answerTextCorrect: '#2E7D32',
    answerTextWrong: '#E64A19',
    
    retryHint: '#9B59B6',
    
    masteredContainer: {
      bg: 'rgba(76, 175, 80, 0.15)',
      border: 'rgba(76, 175, 80, 0.3)',
      text: '#2E7D32',
    },
    
    notificationBadge: {
      bg: '#E74C3C',
      border: '#FFFFFF',
      text: '#FFFFFF',
    },
    
    filterPillActive: { bg: '#9B59B6', text: '#FFFFFF' },
  },

  // Couleurs spécifiques Histoires
  story: {
    pillButton: { bg: '#FFFFFF', border: 'rgba(91, 191, 189, 0.3)' },
    pillButtonSelected: { bg: 'rgba(74, 144, 164, 0.1)', border: '#4A90A4' },
    
    personagesYes: 'linear-gradient(135deg, #4A90A4 0%, #5BBFBD 100%)',
    personagesNo: 'linear-gradient(135deg, #7C5CBF 0%, #A78BFA 100%)',
    
    recapChildName: '#4A90A4',
    recapType: '#F59E0B',
    recapTheme: '#EF4444',
    
    storiesRemainingBadge: { bg: 'rgba(74, 144, 164, 0.1)', text: '#4A90A4' },
    
    modalOverlay: 'rgba(180, 210, 200, 0.97)',
  },

  // Couleurs spécifiques Enfants
  children: {
    cardGradientEven: 'linear-gradient(135deg, #4A90D9 0%, #5BBFBD 100%)',
    cardGradientOdd: 'linear-gradient(135deg, #4ECDC4 0%, #45B7AA 100%)',
    
    cardButton: 'rgba(255, 255, 255, 0.25)',
    cardButtonDelete: 'rgba(255, 255, 255, 0.15)',
    
    addChildButton: {
      bg: 'rgba(255, 255, 255, 0.8)',
      border: 'rgba(91, 191, 189, 0.3)',
      text: '#4A90A4',
    },
    
    reassuranceText: '#9CA3AF',
  },

  // Menu items avec couleurs
  menuItems: [
    { id: 'settings', icon: '⚙️', label: 'Paramètres', path: '/subscription', colors: ['#60A5FA', '#3B82F6'] },
    { id: 'chat', icon: '💬', label: 'Pourquoi', path: '/chat', colors: ['#4A90D9', '#3B82F6'] },
    { id: 'quiz', icon: '❓', label: 'Quiz', path: '/quiz', colors: ['#9B59B6', '#8E44AD'] },
    { id: 'story', icon: '📖', label: 'Raconte', path: '/story', colors: ['#4ECDC4', '#0D9488'] },
    { id: 'history', icon: '🕐', label: 'Historique', path: '/history', colors: ['#52B788', '#059669'] },
    { id: 'children', icon: '👶', label: 'Enfants', path: '/children', colors: ['#F59E0B', '#D97706'] },
    { id: 'admin', icon: '🔧', label: 'Admin', path: '/admin', colors: ['#EF4444', '#DC2626'] },
  ],

  // Tailles de police
  fontSize: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    xxl: '24px',
    xxxl: '32px',
  },

  // Ombres
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.1)',
    md: '0 2px 4px rgba(0, 0, 0, 0.15)',
    lg: '0 4px 8px rgba(0, 0, 0, 0.2)',
    xl: '0 8px 16px rgba(0, 0, 0, 0.25)',
  },

  // Border radius
  borderRadius: {
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    full: '9999px',
  },
};

// URLs des mascottes
export const MASCOTS = {
  standing: 'https://customer-assets.emergentagent.com/job_dialogue-digest-1/artifacts/17m8qo3i_image.png',
  thinking: 'https://customer-assets.emergentagent.com/job_dialogue-digest-1/artifacts/34459ulw_image.png',
  withBook: 'https://customer-assets.emergentagent.com/job_dialogue-digest-1/artifacts/qdtvy9f6_image.png',
  sitting: 'https://customer-assets.emergentagent.com/job_dialogue-digest-1/artifacts/34459ulw_image.png',
  
  // Mascottes quiz (5 variantes)
  quiz: [
    'https://customer-assets.emergentagent.com/job_dialogue-digest-1/artifacts/g9kadylm_image.png',
    'https://customer-assets.emergentagent.com/job_dialogue-digest-1/artifacts/elxpd42u_image.png',
    'https://customer-assets.emergentagent.com/job_dialogue-digest-1/artifacts/kboker7j_image.png',
    'https://customer-assets.emergentagent.com/job_dialogue-digest-1/artifacts/96wgv2ew_image.png',
    'https://customer-assets.emergentagent.com/job_dialogue-digest-1/artifacts/lqvzknd0_image.png',
  ],
  
  // Fallback (ancienne mascotte)
  fallback: 'https://customer-assets.emergentagent.com/job_7b59aa73-04f7-469e-b3b0-3b5db031400b/artifacts/0zxv9crx_02D61451-5FF5-40EF-9C50-17F42BA59024.png',
};

// Options statiques pour les histoires
export const STORY_TYPES = [
  { value: 'sleep', label: 'Pour s\'endormir', emoji: '😴' },
  { value: 'dream', label: 'Pour rêver', emoji: '✨' },
  { value: 'adventure', label: 'Pour partir à l\'aventure', emoji: '🗺️' },
  { value: 'learn', label: 'Pour apprendre', emoji: '🎓' },
  { value: 'laugh', label: 'Pour rigoler', emoji: '😄' },
  { value: 'courage', label: 'Pour être courageux', emoji: '🦸' },
  { value: 'discover', label: 'Pour découvrir le monde', emoji: '🌍' },
  { value: 'imagine', label: 'Pour développer l\'imagination', emoji: '🎨' },
];

export const STORY_THEMES = [
  { value: 'surprise', label: 'Thème surprise', emoji: '🎁' },
  { value: 'party', label: 'La fête', emoji: '🥳' },
  { value: 'school', label: 'L\'école', emoji: '🏫' },
  { value: 'cars', label: 'Les voitures', emoji: '🚗' },
  { value: 'planes', label: 'Les avions', emoji: '✈️' },
  { value: 'knights', label: 'Chevaliers et princesses', emoji: '🏰' },
  { value: 'fairy', label: 'Princesses et contes de fées', emoji: '👑' },
  { value: 'animals', label: 'Les animaux', emoji: '🐾' },
  { value: 'dinosaurs', label: 'Les dinosaures', emoji: '🦖' },
  { value: 'family', label: 'La famille', emoji: '👨‍👩‍👧‍👦' },
  { value: 'unicorns', label: 'Les licornes', emoji: '🦄' },
  { value: 'space', label: 'L\'espace et les étoiles', emoji: '🚀' },
  { value: 'superheroes', label: 'Les super-héros', emoji: '🦸' },
  { value: 'music', label: 'La musique et la danse', emoji: '🎵' },
  { value: 'robots', label: 'Les robots', emoji: '🤖' },
  { value: 'custom', label: 'Thème personnalisé', emoji: '✏️' },
];

export default THEME;
